<template>
  <div>
    <div class="header__banner-basket">
      <span class="badge badge-pill badge-success">Panier</span>
      <span class="custom__trait"></span>
      <span>Paiement</span>
    </div>
    <div class="custom_container">
      <div class="basket__content">
        <div class="custom__card-left">
          <div class="custom__card-header">
            <div class="custom__card-header--title">
              <h6 class="font-weight-bold">
                Mon panier ({{ baskets.length }}
                {{ baskets.length > 1 ? "produits" : "produit" }})
              </h6>
            </div>
            <div class="custom__card-header--total">
              <h6 class="font-weight-bold">
                Total : {{ $format(Math.round(amount)) }} Fcfa
              </h6>
            </div>
          </div>
          <div v-if="baskets.length > 0" class="custom__card-body">
            <div
              v-for="(item, key) in baskets"
              :key="key"
              class="mb-3 custom__panel"
            >
              <div class="custom__icon">
                <svg
                  v-if="item.product.product_id === 2"
                  class="custom__height"
                  viewBox="0 0 73 73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.572266"
                    width="72"
                    height="72"
                    rx="36"
                    fill="#D39E0A"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.4767 18.5898C36.0786 18.1217 36.9214 18.1217 37.5232 18.5898L52.5232 30.2565C52.9292 30.5723 53.1666 31.0578 53.1666 31.5721V49.9054C53.1666 51.2315 52.6399 52.5033 51.7022 53.441C50.7645 54.3786 49.4927 54.9054 48.1666 54.9054H24.8333C23.5072 54.9054 22.2355 54.3786 21.2978 53.441C20.3601 52.5033 19.8333 51.2315 19.8333 49.9054V31.5721C19.8333 31.0578 20.0708 30.5723 20.4767 30.2565L35.4767 18.5898ZM23.1666 32.3872V49.9054C23.1666 50.3475 23.3422 50.7714 23.6548 51.0839C23.9674 51.3965 24.3913 51.5721 24.8333 51.5721H48.1666C48.6087 51.5721 49.0326 51.3965 49.3452 51.0839C49.6577 50.7714 49.8333 50.3475 49.8333 49.9054V32.3872L36.5 22.0169L23.1666 32.3872Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M29.8333 36.5721C29.8333 35.6516 30.5795 34.9054 31.5 34.9054H41.5C42.4205 34.9054 43.1666 35.6516 43.1666 36.5721V53.2388C43.1666 54.1592 42.4205 54.9054 41.5 54.9054C40.5795 54.9054 39.8333 54.1592 39.8333 53.2388V38.2388H33.1666V53.2388C33.1666 54.1592 32.4205 54.9054 31.5 54.9054C30.5795 54.9054 29.8333 54.1592 29.8333 53.2388V36.5721Z"
                    fill="white"
                  />
                </svg>
                <svg
                  v-if="item.product.product_id === 3"
                  class="custom__height"
                  viewBox="0 0 73 73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.572266"
                    width="72"
                    height="72"
                    rx="36"
                    fill="#D39E0A"
                  />
                  <path
                    d="M52.6202 21.2162C52.3581 20.8471 52.0186 20.5396 51.6254 20.3152C51.2323 20.0908 50.7949 19.9548 50.3438 19.9168C49.8927 19.8787 49.4387 19.9396 49.0135 20.095C48.5883 20.2505 48.2022 20.4968 47.882 20.8168L41.6831 27.0158L25.4816 22.2504C25.241 22.1796 24.9857 22.1749 24.7427 22.2369C24.4996 22.2988 24.2778 22.4252 24.1005 22.6026L22.313 24.3898C22.1655 24.5373 22.0529 24.7161 21.9835 24.9128C21.9141 25.1096 21.8897 25.3194 21.912 25.5268C21.9344 25.7342 22.0029 25.934 22.1127 26.1115C22.2224 26.2889 22.3705 26.4395 22.546 26.5522L34.4846 34.2141L33.3955 35.3033C32.4338 36.27 31.5591 37.3196 30.7817 38.44L22.5287 37.5596C22.3205 37.5374 22.11 37.5621 21.9127 37.6319C21.7153 37.7017 21.536 37.8147 21.388 37.9628L20.2442 39.1064C20.096 39.2546 19.9829 39.4342 19.9132 39.6318C19.8434 39.8295 19.8189 40.0403 19.8414 40.2487C19.8639 40.4571 19.9327 40.6579 20.043 40.8362C20.1532 41.0144 20.302 41.1658 20.4784 41.279L27.386 45.7119L31.8256 52.6298C31.938 52.805 32.0883 52.9527 32.2653 53.0622C32.4423 53.1717 32.6416 53.2401 32.8485 53.2624C33.0555 53.2847 33.2648 53.2604 33.4611 53.1912C33.6573 53.122 33.8356 53.0097 33.9828 52.8625L35.1386 51.7066C35.2856 51.5596 35.3978 51.3816 35.467 51.1856C35.5363 50.9895 35.5608 50.7805 35.5387 50.5738L34.658 42.3162C35.7784 41.5389 36.828 40.6641 37.7946 39.7023L38.8837 38.6133L46.538 50.5397C46.6516 50.7167 46.8034 50.866 46.9823 50.9767C47.1612 51.0873 47.3627 51.1564 47.5718 51.179C47.7809 51.2016 47.9925 51.177 48.1909 51.107C48.3893 51.0371 48.5694 50.9236 48.7182 50.7748L50.4905 49.0024C50.6694 48.8236 50.7967 48.5998 50.8592 48.3547C50.9217 48.1097 50.917 47.8523 50.8456 47.6096L46.0823 31.4149L52.1635 25.3335C53.2592 24.2377 53.5259 22.4736 52.6202 21.2162Z"
                    fill="white"
                  />
                </svg>
                <svg
                  v-if="item.product.product_id === 1"
                  class="custom__height"
                  viewBox="0 0 73 73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.572266"
                    width="72"
                    height="72"
                    rx="36"
                    fill="#D39E0A"
                  />
                  <path
                    d="M36.5 19.9058C27.3066 19.9058 19.8333 27.3791 19.8333 36.5724C19.8333 45.7591 27.3066 53.2391 36.5 53.2391C45.6866 53.2391 53.1666 45.7591 53.1666 36.5724C53.1666 27.3791 45.6866 19.9058 36.5 19.9058ZM34.1066 49.9258C34.1 49.9258 34.1 49.9258 34.0933 49.9258C28.9 48.9924 24.74 45.1058 23.3933 40.0658C26.4066 39.9258 29.0933 40.7458 31.0533 42.4791C33 44.2058 34.1533 46.7791 34.46 49.9724C34.3466 49.9591 34.2266 49.9458 34.1066 49.9258ZM33.1266 38.0991C33.1266 36.2391 34.64 34.7258 36.5 34.7258C38.36 34.7258 39.8733 36.2391 39.8733 38.0991C39.8733 39.9591 38.36 41.4724 36.5 41.4724C34.64 41.4724 33.1266 39.9591 33.1266 38.0991ZM38.9 49.9258C38.8933 49.9258 38.8933 49.9258 38.8867 49.9258C38.7733 49.9458 38.6533 49.9591 38.5333 49.9724C38.84 46.7791 39.9933 44.1991 41.94 42.4791C43.8933 40.7458 46.5867 39.9191 49.6 40.0658C48.2533 45.1058 44.0933 48.9924 38.9 49.9258ZM49.9466 34.7258C49.9466 34.7324 49.94 34.7458 49.94 34.7524C50 35.2124 50.04 35.6858 50.06 36.1591C48.42 36.0058 47.0533 35.3858 45.62 34.7258C43.42 33.7191 40.92 32.5724 36.52 32.5724C32.12 32.5724 29.6066 33.7191 27.3933 34.7258C25.9533 35.3858 24.58 36.0058 22.94 36.1591C22.96 35.6858 23 35.2124 23.06 34.7458C23.06 34.7391 23.0533 34.7324 23.0533 34.7258C23.0533 34.6658 23.0733 34.6124 23.0866 34.5591C24.06 28.0258 29.7 22.9924 36.5 22.9924C43.2933 22.9924 48.92 28.0124 49.9067 34.5324C49.9267 34.5924 49.9466 34.6591 49.9466 34.7258Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="custom__content">
                <h6 class="subscription__text">
                  Souscription à Assurance
                  <span v-if="item.product.product_id === 2"
                    >Multirisque Habitation “APEFA”</span
                  >
                  <span v-if="item.product.product_id === 3">Voyage</span>
                  <span
                    v-if="
                      item.product.product_id === 1 &&
                      item.product.data.type_engin == '1'
                    "
                    >Auto</span
                  >
                  <span
                    v-if="
                      item.product.product_id === 1 &&
                      item.product.data.type_engin == '2'
                    "
                    >Auto 2 ou 3 roues</span
                  >
                </h6>
                <h6 class="subscription__price">
                  {{ $format(Math.round(item.detail.total)) }} Fcfa
                </h6>
                <span class="remove__btn" @click="removeBasket(item)">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5 1.48227L13.09 0.0722656L7.5 5.66227L1.91 0.0722656L0.5 1.48227L6.09 7.07227L0.5 12.6623L1.91 14.0723L7.5 8.48227L13.09 14.0723L14.5 12.6623L8.91 7.07227L14.5 1.48227Z"
                      fill="#9592A0"
                    />
                  </svg>
                  Retirer du panier
                </span>
              </div>
              <div class="item_check">
                <input
                  @click="toEnalble(item)"
                  v-model="item.check"
                  class="mb_check"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="custom__card-right">
          <svg
            v-if="summary.reduce"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.5 12.0723C1.5 5.99713 6.42487 1.07227 12.5 1.07227C18.5751 1.07227 23.5 5.99713 23.5 12.0723C23.5 18.1474 18.5751 23.0723 12.5 23.0723C6.42487 23.0723 1.5 18.1474 1.5 12.0723Z"
              fill="#53AC32"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.8107 8.11523C18.2012 8.50576 18.2012 9.13892 17.8107 9.52945L11.6036 16.0294C11.2131 16.42 10.5799 16.42 10.1894 16.0294L7.18938 13.0294C6.79885 12.6389 6.79885 12.0058 7.18938 11.6152C7.5799 11.2247 8.21307 11.2247 8.60359 11.6152L10.8965 13.9081L16.3965 8.11523C16.787 7.72471 17.4202 7.72471 17.8107 8.11523Z"
              fill="white"
            />
          </svg>
          <span class="promo__title">{{ title }}</span>
          <div v-if="!summary.reduce" class="promo__form">
            <div class="form-group">
              <input v-model="code" type="text" class="form-control" />
              <div v-if="errors.code" style="color: red">
                {{ errors.code[0] }}
              </div>
            </div>
            <div class="promo__form-button">
              <button
                v-if="disabledItem"
                @click="applyPromo()"
                type="button"
                class="btn btn-outline-primary"
              >
                Appliquer
              </button>
              <button
                v-else
                disabled
                type="button"
                class="btn btn-outline-primary"
              >
                Appliquer
              </button>
            </div>
          </div>
          <div>
            <div class="form-group">
              <label>Modes de paiement</label>
              <select
                @change="changePayment"
                v-model="mode"
                class="form-control"
              >
                <option
                  v-for="(item, key) in paymentsList"
                  :key="key"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <div v-if="errors.mode" style="color: red">
                {{ errors.mode[0] }}
              </div>
            </div>
          </div>
          <div v-if="mode == '2' || mode == '3'">
            <div class="form-group">
              <label>Numéro de paiement</label>
              <input v-model="phone" type="number" class="form-control" />
              <div v-if="errors.phone" style="color: red">
                {{ errors.phone[0] }}
              </div>
            </div>
          </div>
          <hr />
          <div class="summary__detail mb-2">
            <span class="summary__detail-text">Sous-total (Net)</span>
            <span class="summary__detail-price"
              >{{ $format(Math.round(net_amount)) }} Fcfa</span
            >
          </div>
          <div v-if="fees_amount > 0" class="summary__detail mb-2">
            <span class="summary__detail-text">Frais de dossier</span>
            <span class="summary__detail-price"
              >{{ $format(Math.round(fees_amount)) }} Fcfa</span
            >
          </div>
          <div v-if="summary.reduce !== 0" class="summary__detail mb-2">
            <span class="summary__detail-text"
              >Reduction ({{ this.code }})</span
            >
            <span class="summary__detail-price"
              >{{ $format(Math.round(summary.reduce)) }} Fcfa</span
            >
          </div>
          <div class="summary__detail">
            <span class="summary__detail-text font-weight-bold">Total TTC</span>
            <span class="summary__detail-price font-weight-bold"
              >{{
                summary.reduce
                  ? $format(Math.round(amount - summary.reduce))
                  : $format(Math.round(amount))
              }}
              Fcfa</span
            >
          </div>
          <button
            v-if="disabledItem"
            @click="checkOut"
            type="button"
            class="btn btn-primary btn-block mt-3"
          >
            Valider la commande
          </button>
          <button
            v-else
            disabled
            type="button"
            class="btn btn-primary btn-block mt-3"
          >
            Valider la commande
          </button>
        </div>
      </div>
    </div>
    <div class="payment__info">
      <div class="payment__info--text">Moyens de paiement acceptés</div>
      <div class="payment__widget">
        <img :src="$assets('images/payment.png')" width="140" alt="payment" />
      </div>
    </div>
    <div class="voyage__info">
      <div
        class="happy__young"
        :style="`background: url(${$assets(
          'images/young.png'
        )}) no-repeat center;background-size: cover;`"
      ></div>
      <div class="hire__me">
        <div class="background__info">
          <div class="svg__hire">
            <svg
              width="188"
              height="188"
              viewBox="0 0 188 188"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z"
                fill="#E8EFFF"
              />
            </svg>
          </div>
          <div class="hire__me--text">Contactez-nous</div>
          <div class="hire__me--description">
            Si vous avez des questions ou rencontrez une difficulté,
            contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
          </div>
          <div class="hire__me--button">
            <button class="btn btn-secondary">Parler à un expert</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api, EventBus } from "../../helpers/shared";
let loader = null;
export default {
  name: "pannier",
  props: ["types"],
  data: () => ({
    baskets: [],
    toSend: [],
    errors: [],
    amount: 0,
    net_amount: 0,
    fees_amount: 0,
    promo: "",
    title: "",
    loading: false,
    summary: {
      reduce: 0,
    },
    code: "",
    paymentsList: [],
    mode: 1,
    phone: "",
  }),
  mounted() {
    //const element = JSON.parse(localStorage.getItem('carts'));
    const element = JSON.parse(
      this.$storage.decryptString(this.$storage.getItem("carts"))
    );
    if (Array.isArray(element)) {
      this.baskets = element;
      this.toSend = [...element];
      this.getTotal();
    }
    if (this.promo == "") {
      this.title = "Code promotionnel";
    } else this.title = "Code promo appliqué avec succès";

    this.paymentsList = JSON.parse(this.types);
  },
  computed: {
    disabledItem() {
      return (this.toSend.length === 0 || this.loading === true) ? false : true
    },
  },
  methods: {
    changePayment() {
      this.phone = "";
      this.errors = [];
    },
    toEnalble(item) {
      item.check = !item.check;
      if (item.check) {
        let index = this.toSend.indexOf(item);
        if (index === -1) this.toSend.push(item);
      } else {
        let index = this.toSend.indexOf(item);
        this.toSend.splice(index, 1);
      }
      if (this.toSend.length > 0) {
        this.getTotal();
        if (this.summary.perc) {
          let amount = this.amount;
          this.summary.reduce = Math.round(amount * this.summary.perc);
        }
      } else {
        if (this.summary.perc) {
          this.summary.reduce = 0;
        }
        this.getTotal();
      }
    },
    getTotal() {
      let amount = 0;
      let fees = 0;
      let net = 0;
      this.toSend.map((item) => {
        amount += item.detail.total;
        fees += item.detail.fees || 0;
        net += item.detail.net || (item.detail.total - (item.detail.fees || 0));
      });
      this.amount = amount;
      this.fees_amount = fees;
      this.net_amount = net;
    },
    removeBasket(item) {
      let i = this.toSend.indexOf(item);
      if (i != -1) {
        this.toSend.splice(i, 1);
        let index = this.baskets.indexOf(item);

        this.baskets.splice(index, 1);
        let i = this.toSend.indexOf(item);

        let cloneBaskets = JSON.parse(JSON.stringify(this.baskets));

        cloneBaskets.map((el) => {
          el.check = true;
        });

        this.$storage.setItem(
          "carts",
          this.$storage.encryptString(JSON.stringify(cloneBaskets))
        );

        this.getTotal();
        EventBus.$emit("remove");
      } else {
        this.$toasted.global.error({
          message: "Impossible de supprimer si l'assurance n'est pas coché.",
        });
      }
    },
    applyPromo() {
      loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.loading = true;
      axios
        .post(api("apply-promo"), { code: this.code, amount: this.amount })
        .then((response) => {
          loader.hide();
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.summary = response.data.summary;
            this.title = "Code promo appliqué avec succès";
          } else {
            this.$toasted.global.error({
              message: "Ce code est erroné ou à expirer",
            });
          }
        })
        .catch((error) => {
          loader.hide();
          if (error.response.status === 422) {
            this.loading = false;
            this.errors = error.response.data.errors;
          } else
            this.$toasted.global.error({
              message:
                "Vous devez vous connecter pour procéder à cette opération",
            });
        });
    },
    checkOut() {
      loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.loading = true;

      //récupérer la diférence
      let result = this.baskets.filter((basket) =>
        this.toSend.some((send) => basket.uuids !== send.uuids)
      );

      let baskets = [];
      this.toSend.map((item) => {
        let part = item.product || item;
        part.uuid = item.uuid;
        if (item.detail) part.detail = item.detail;
        if (item.files) part.files = item.files;
        baskets.push(part);
      });
      axios
        .post(api("assurance/checkout"), {
          code: this.code,
          payment_id: this.mode,
          phone: this.phone,
          baskets: baskets,
        })
        .then((response) => {
          loader.hide();
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            const model = response.data.model;
            //localStorage.setItem('details', JSON.stringify(model))
            this.$storage.setItem(
              "details",
              this.$storage.encryptString(JSON.stringify(model))
            );

            if (result.length == this.baskets.length) {
              //localStorage.setItem('carts', JSON.stringify([]))
              this.$storage.setItem(
                "carts",
                this.$storage.encryptString(JSON.stringify([]))
              );
            } else {
              let cloneBaskets = JSON.parse(JSON.stringify(result));
              cloneBaskets.map((el) => {
                el.check = true;
              });
              //localStorage.setItem('carts', JSON.stringify(cloneBaskets))
              this.$storage.setItem(
                "carts",
                this.$storage.encryptString(JSON.stringify(cloneBaskets))
              );
            }
            this.$toasted.global.all({
              message:
                model.state == "paid"
                  ? "Souscription enrégistrée. Veillez confirmer le paiement"
                  : "Souscription enrégistrée",
            });
            setTimeout(() => {
              this.$router("assurance/checkout");
            }, 400);
          } else {
            this.$toasted.global.error({
              message: "Une erreur est survenu lors de l'enregistrement",
            });
          }
        })
        .catch((error) => {
          loader.hide();
          this.loading = false;
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          } else
            this.$toasted.global.error({
              message:
                // "Vous devez vous connecter pour procéder à cette opération",
                "Une erreur est survenu lors de l'opération",
            });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.header__banner-basket {
  height: 68px;
  background: #ffffff;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 100px 100px 100px;
  grid-gap: 10px;
}
.custom__trait {
  border: 1px dashed #6d7580;
}
.basket__content {
  display: grid;
  margin-top: 30px;
  grid-template-columns: 2fr 1fr;
  grid-gap: 30px;
  margin-bottom: 30px;
  .custom__card-left {
    height: auto;
    padding: 24px;
    background: #ffffff;
    color: #0b2e13;
    .custom__card-header {
      display: grid;
      grid-template-columns: 2fr 1fr;
    }
    .custom__card-header--total {
      justify-self: end;
      font-weight: bold;
    }
    .custom__card-header--title {
      font-weight: bold;
    }
  }
  .custom__card-right {
    padding: 16px 24px;
    min-height: 255px;
    max-height: auto;
    background: #ffffff;
    color: #0b2e13;
    hr {
      color: #c4c4c4;
    }
    .promo__form {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-gap: 10px;
      .promo__form-button {
        justify-self: end;
      }
    }
  }
  .custom__panel {
    border: 1px solid #dadee3;
    box-sizing: border-box;
    border-radius: 8px;
    height: 115px;
    min-height: 115px;
    padding: 16px;
    display: grid;
    grid-template-columns: 100px 2fr 1fr;
    .remove__btn {
      color: #9592a0;
      cursor: pointer;
    }
  }
  .custom__content {
    .subscription__text {
      font-weight: bold;
    }
    .subscription__price {
      color: #ea5455;
    }
  }
  .promo__title {
    font-weight: 600;
    font-size: 15px;
    color: #6e6b7b;
  }
  .summary__detail {
    display: grid;
    grid-template-columns: 1fr 1fr;
    .summary__detail-text {
      justify-self: left;
    }
    .summary__detail-price {
      justify-self: end;
    }
  }
}
.custom__height {
  height: 73px;
  width: 73px;
}
.custom_container {
  margin-left: 40px;
  margin-right: 40px;
}
@media only screen and (max-width: 900px) {
  .basket__content {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
  }
}
@media only screen and (max-width: 550px) {
  .custom_container {
    margin-left: 10px;
    margin-right: 10px;
  }
  .basket__content {
      margin-top: 15px;
  }
  .custom__card-left {
      padding: 15px !important;
  }
  .custom__panel {
    height: auto !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-auto-flow: row !important;
    padding: 10px !important;
    grid-gap: 5px;
  }
  .promo__form {
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-auto-flow: row !important;
    grid-gap: 5px !important;
  }
  .custom__height {
    height: 55px;
    width: 55px;
  }
}
.mb_check {
  display: block;
}
.item_check {
  place-self: end;
  align-self: center;
}
</style>
